{
  "customer_search_select": {
    "search_placeholder": "Search by name or email",
    "no_options": "No matching customers"
  },
  "company_sync_errors_alert": {
    "company_title": "{error_count, plural, =1 {This company has a sync error} other {This company has sync errors}}",
    "locations_title": "{error_count, plural, =1 {1 of this company's locations has a sync error} other {This company's locations have # sync errors}}",
    "section_title": "{error_count, plural, =1 {This location has a sync error} other {This location has sync errors}}",
    "contacts_title": "{error_count, plural, =1 {1 of this location's customers has a sync error} other {This location's customers have # sync errors}}",
    "load_error_title": "Sync errors couldn't be loaded"
  },
  "import_companies_modal": {
    "title": "Import companies and locations",
    "intro": "Upload a CSV file to create or update companies and their locations. Companies are matched to existing companies by name, and locations by name within their company. Blank cells keep their current values.",
    "linking": "Give every row a unique ref. Location rows use parent_ref to name the company or location they sit under.",
    "primary_customer": "New companies need a primary customer. Set primary_customer_lookup to sparklayer, email or platform to say how primary_customer identifies them.",
    "lists": "Separate multiple price lists or sales agent groups with a | character.",
    "dates": "Dates can be in your spreadsheet's usual format, for example 31/01/2026 or 31 Jan 2026. Use YYYY-MM-DD to avoid any confusion between day and month.",
    "table_caption": "Example CSV",
    "download_template": "Download CSV template",
    "results": {
      "summary": "{created} created, {updated} updated, {failed} failed, {skipped} skipped.",
      "dates_read_as": "Dates that could be read either way, such as 03/04/2026, were read as {order, select, mdy {month/day/year} other {day/month/year}}.",
      "partial_title": "Some rows were not imported",
      "failed_title": "No rows were imported",
      "description": "Fix these rows and upload the file again. Rows that were already imported are matched by name, so they will be updated rather than duplicated.",
      "success": "All rows were imported successfully."
    },
    "notifications": {
      "success": "Companies imported.",
      "partial": "Some rows could not be imported.",
      "failed": "No rows could be imported."
    }
  },
  "csv_import_modal": {
    "file_hint": "CSV files only, up to 1,000 rows",
    "select_file": "Please select a CSV file to import.",
    "done_button": "Done",
    "errors": {
      "title": "CSV errors",
      "description": "Fix these problems and upload the file again. Nothing has been imported."
    },
    "notifications": {
      "file_errors": "There were issues with your CSV file."
    }
  },
  "import_section_customers_modal": {
    "title": "Assign customers to locations",
    "intro": "Upload a CSV file to add customers to company locations. Each row adds one customer to one location with a role. Customers already in a location have their role updated, and nobody is removed from a location.",
    "customer": "Set customer_lookup to sparklayer, email or platform to say how the customer column identifies them.",
    "company_and_section": "Set company_lookup and location_lookup to sparklayer, platform, integration or name. Locations are looked up within their company.",
    "rules": "Customers can only be assigned to locations without sub-locations, and a customer can only belong to one company.",
    "role": "Set role to the slug of a customer role, for example main or limited-customer. Sales roles can't be assigned.",
    "table_caption": "Example CSV",
    "download_template": "Download CSV template",
    "results": {
      "summary": "{created} assigned, {updated} updated, {failed} failed.",
      "partial_title": "Some rows were not imported",
      "failed_title": "No rows were imported",
      "description": "Fix these rows and upload the file again. Customers already assigned by this file will only have their role set again.",
      "success": "All customers were assigned successfully."
    },
    "notifications": {
      "success": "Customers assigned to locations.",
      "partial": "Some rows could not be imported.",
      "failed": "No rows could be imported."
    }
  },
  "addresses_card": {
    "title": "Addresses",
    "description": "Addresses customers in this location can choose at checkout. Addresses shared by a parent location are listed too, and can only be edited where they were added.",
    "add": "Add address",
    "empty": "No addresses yet.",
    "save_first": "Save to start adding addresses.",
    "load_error": "Addresses couldn't be loaded.",
    "inherited_from": "Inherited from {name}",
    "shared": "Shared with sub-locations",
    "table": {
      "caption": "Addresses",
      "headings": {
        "label": "Label",
        "address": "Address"
      }
    },
    "modal": {
      "add_title": "Add address",
      "edit_title": "Edit address"
    },
    "fields": {
      "label": "Label",
      "first_name": "First name",
      "last_name": "Last name",
      "company": "Company",
      "address_line1": "Address line 1",
      "address_line2": "Address line 2",
      "city": "City",
      "postal_code": "Postcode",
      "phone": "Phone",
      "country_code": "Country",
      "country_placeholder": "Select a country",
      "region_code": "Region",
      "available_to_descendants": "Share with sub-locations",
      "available_to_descendants_description": "Customers in locations below this one can also use this address."
    },
    "delete_confirm_title": "Delete address",
    "delete_confirm_body": "Are you sure you want to delete \"{name}\"? Any location using it as a default address will no longer have one.",
    "defaults": {
      "description": "Pre-selected at checkout for customers in this location. Each can be any address listed below, and both can be the same.",
      "shipping_label": "Default shipping address",
      "billing_label": "Default billing address",
      "inherit": "Inherit from parent",
      "none": "No default"
    },
    "lookup": {
      "label": "Find an address",
      "placeholder": "Start typing an address",
      "hint": "Type at least 3 characters to search",
      "no_results": "No matching addresses",
      "error": "Address lookup isn't available right now. Enter the address manually."
    },
    "errors": {
      "country": "Choose a country from the list",
      "region": "Choose a region for this country"
    }
  }
}
